module.exports = __webpack_public_path__ + "static/media/tr.43c1bc89.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/languages/tr.svg
// module id = 1694
// module chunks = 0